// extracted by mini-css-extract-plugin
export default {"home_history_mobile":"MobileHistoryBlock_home_history_mobile__l8HUk"};